import { render, staticRenderFns } from "./OAuth2Login.vue?vue&type=template&id=2e82e698&scoped=true&"
import script from "./OAuth2Login.vue?vue&type=script&lang=js&"
export * from "./OAuth2Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e82e698",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e82e698')) {
      api.createRecord('2e82e698', component.options)
    } else {
      api.reload('2e82e698', component.options)
    }
    module.hot.accept("./OAuth2Login.vue?vue&type=template&id=2e82e698&scoped=true&", function () {
      api.rerender('2e82e698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/oauth2/OAuth2Login.vue"
export default component.exports